// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"c621851b10ea33e41a41","303":"1d891095f7cdab05bc4d","495":"7cbab0f7937bde71a81f"}[chunkId] + ".js";
};